import { encryptData } from "./Functions";
import { protectedApi } from "./protectedApi";
import { APIS } from "../constants/apiConstant";

export async function sendSalarySlipEmail({ pdfBlob, pdfFileName, ...metadata }) {
  const formData = new FormData();
  formData.append("file", pdfBlob, pdfFileName || "salary-slip.pdf");
  formData.append("payload", encryptData(metadata));

  const response = await protectedApi({
    url: APIS.SALARY_SLIP_SEND_EMAIL,
    method: "POST",
    data: formData,
  });
  return response?.data;
}
